import { Collection } from 'core/model';

class DeviceWarningsCollection extends Collection {
  get url() {
    return '/api/ui/devices/warnings';
  }
}

export default DeviceWarningsCollection;
